// src/components/sections/CTA.jsx
// Final call-to-action - light theme

import React from 'react';
import useInView from '../../hooks/useInView';

const CTA = () => {
  const [ref, inView] = useInView({ threshold: 0.2 });

  return (
    <section id="contact" className="py-16 md:py-32 relative overflow-hidden bg-white/60 backdrop-blur-sm">
      {/* Background glow */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full blur-[120px] opacity-10"
          style={{ background: 'radial-gradient(circle, rgba(13,148,136,0.4), transparent 70%)' }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div
          ref={ref}
          className={`text-center max-w-2xl mx-auto transition-all duration-700 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          

          <h2 className="text-2xl md:text-4xl font-display font-bold tracking-tight mb-6 text-gt-dark-100">
            Ready to track{' '}
            <span className="text-gradient">smarter?</span>
          </h2>

          <p className="text-base md:text-lg mb-10 text-gt-dark-400">
            Whether you need mileage tracking, SARS-compliant logbooks, or enterprise fleet management
            — GPS Tech has a platform for you.
          </p>

          
        </div>
      </div>
    </section>
  );
};

export default CTA;